module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/55c91836a022ad9c8bc36df8d31c0061.gif";